import React from "react";
import {withRouter} from 'react-router-dom';
import {version, RELEATIVE_PATH} from '../../config';
import Header from "./header";
import PushUpgradeHeader from "./push-upgrade-header";
import CustomHeader from "./custom-header";
import CommonLogo from "./common-logo";

const MainHeader = (props) => {
  let removePath =props.location.pathname.replace(RELEATIVE_PATH,"");
  let title=removePath.replace(/\//g," ");
  title=title.split(' ')[0];
  title=title.includes('upgrade-status')?'upgrade-status':title;
  return (
    <>
      { (title==="upgrade-status"||title==='tacc'||title==="automation-execution" ||title==="salesforce-login" || title==="salesforce-opt" || title==="boat" || title==="demo") ?<CommonLogo />:<Header/> }
    </>
  );
}
export default withRouter(MainHeader);